import { render, staticRenderFns } from "./ChargeEdit.vue?vue&type=template&id=66352ce7&scoped=true"
import script from "./ChargeEdit.vue?vue&type=script&lang=js"
export * from "./ChargeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66352ce7",
  null
  
)

export default component.exports